import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;
export async function updatePhoneNumber(phoneNumber) {
  // Retrieve the user object from localStorage and extract the email.
  const storedUser = localStorage.getItem("user");
  const email = storedUser ? JSON.parse(storedUser).email : "";

  const payload = {
    phoneNo: phoneNumber,
    email: email,
  };

  try {
    const response = await axios.post(
      `${baseUrl}/api/Coltec/UpdateMobile`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error updating phone number"
    );
  }
}
